/*jshint esversion: 6 */
import React, { Component } from "react";
import About from "./components/About";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Certificate from "./components/Certificate";
import Skills from "./components/Skills";
import Profile from "./components/Profile";
import foto from './resources/Fotohv.jpg'

class App extends Component {
  render() {
    const person = {
      avatar:`${foto}`,
      name: "Carlos Fajardo",
      profession: "Software Engineer",
      bio:
        "© FullStack Developer - Software Engineer with a keen interest in software development and knowledge in programming languages such as C#, VB, ASP.NET Core & MVC, Entity Framework Core, services ApiRest, SQL Server, Redux with NGRX, Angular, Angular JS, React, HTML 5 and CSS3, Bootstrap, Dev-Extreme, JavaScript, database NoSQL like Mongo and Firebase, version control system like Git - GitHub, TFS",
      address: "Bogota, Colombia Phone: 3184043192",
      social: [
        { name: "facebook", url: "https://www.facebook.com/ChadFp" },
        { name: "github", url: "https://github.com/cafajardop" },
        {
          name: "linkedin",
          url: "https://www.linkedin.com/in/carlos-fajardo-1550737a/",
        },
        {
          name: "google-plus",
          url: "https://fernando-herrera.com/logros/#/cafajardop03@gmail.com/",
        },
        {
          name: "twitter",
          url:
            "https://drive.google.com/file/d/1Y79e7mGIHR5Tjl90CgGI19fJLxzrrrG8/view?usp=sharing",
        },
      ],
      profile: [
        {
          personal:
            "Software Engineer - Project Management Specialist in Business Intelligence.",
            profileDescription:
            "My name is Carlos Fajardo, I am from Bogotá Colombia, I’m Software Engineer, for the last few years, I have been working with the web, I have experience in modern web technologies, I work with languages such as : Backend Node JS, C #, VB, ASP.NET Core & MVC, Entity Framework, Core, ApiRest Services. Frontend Angular, React, Redux, AngularJS, JavaScript, HTML 5 and CSS3 Bootstrap, Dev-Extreme Database: SQL Server, NoSQL Mongo and Firebase databases. Version control like Git, GitHub, TFS, Bitbucket  Sourcetree etc. Scrum methodology",
            profileDescription2:
            "I believe in clean code and the importance of good software architecture.",
        },
      ],
      experience: [
        {
          jobTitle: "Senior Software Engineer (FullStack) ",
          company: "Stefanini Group ",
          startDate: "Nov 2020",
          endDate: "Currently",
          jobDescription:
            "Design and creation of pages with React JS, implementation of Redux, HTML5 CSS3, Material UI, Bootstrap, PWA, creation of Backend services with Nodejs and Asp.Netcore 5 (Microservices), implementation of Scrum, use of the TFS / Azure DevOps platform as tools monitoring of projects and integration and continuous deployment of software, management of repositories with Azure and Git management of Sourcetree tool, OAuth protocols, authentication with Active Directory, B2B, B2C, JWT",
        },
        {
          jobTitle: "Senior Software Engineer",
          company: "DigitalWare",
          startDate: "Jun 2019",
          endDate: "Nov 2020",
          jobDescription:
            "Design and creation of pages with Angular 9, React JS and React Native, implementation of Redux, creation of ApiRest services and microservices with Asp.Netcore 5 for the functionalities of Davinci Ophelia Suite, Implementation of Scrum in the development of the Ophelia Suite platform and their business verticals, use of the TFS / Azure DevOps platform as project tracking tools, Azure repository management, integration and continuous software deployment.",
        },

        {
          jobTitle: "Senior Software Engineer ",
          company: "Heon On Line",
          startDate: "Jan 2015",
          endDate: "Jun 2019",
          jobDescription:
            "Design and develop new developments with asp.net, C # AngularJS, SQL databases, correction of (Bugs) program maintenance, requirements analysis, search for continuous improvement of applications, technical support to the area and customers.",
        },
        {
          jobTitle: "Junior Database Analyst",
          company: "I.A.C  Gestión Administrativa",
          startDate: "Jan 2009",
          endDate: "Jan 2015",
          jobDescription:
            "Development and implementation of processes on databases in Microsoft SQL Server Generation and execution of DTS (2000) and ETL (2008) with Integration Services, reporting services, Execution of Stored Procedures and Functions in Microsoft SQL Server, triggers, subqueries, management of errors, execution and follow-up of Software Unit Tests before publishing in production Generation of daily production orders for the execution of processes in the Computer Center. Generation of reports in databases to respond to requirements of the regional, government entities and the Superintendency of Health.",
        },
      ],
      education: [
        {
          degree: "Project Management Specialist in Business Intelligence",
          institution: "Politecnico Gran Colombiano",
          startDate: "Jan 2018",
          endDate: "Jan 2019",
          description:
            "Professional with the ability to determine the technological resources according to the size of a company for the construction of business intelligence solutions. Determine administrative processes to establish objectives, strategies, indicators, and goals to be measured for decision-making. Ability to propose a Business Intelligence implementation project, using an appropriate and systemic methodology that makes it easier for organizations to implement it.",
        },
        {
          degree: "Software Engineer",
          institution: "Fundacion Universitaria Unipanamericana",
          startDate: "Jan 2014",
          endDate: "Oct 2017",
          description:
            "Integral professional capable of designing, understanding, assimilating, adapting, incorporating, specifying, integrating, commissioning, maintaining and operating, technologies and software, to solve specific needs, with criteria of opportunity and economic efficiency.",
        },
        {
          degree:
            "Technologist in Analysis and Development of Information Systems",
          institution: "Sena",
          startDate: "Jan 2012",
          endDate: "Oct 2013 24 Meses",
          description:
            "Specialized professional in the area of software and computer engineering, in charge of application development in terms of its design and obtaining of algorithms, as well as analyzing the possible utilities and modifications necessary of operating systems for greater efficiency of a computer system. Another mission of these people is to provide technical support to users. Knowledge of the traditional paradigm of software engineering and the traditional cascading software lifecycle. Functional modeling: Data flow diagram, status diagram, etc. Data modeling and its techniques: Entity-relationship diagram, relational model, etc.             Knowledge of technology: software architecture, databases, etc.",
        },
        {
          degree: "English level B1 ",
          institution: "Academia de Idiomas SMART",
          startDate: "Jun 2021",
          endDate: "Currently",
          description:
            "",

        },
        {
          degree: "English level A2 ",
          institution: "Academia de Idiomas SMART",
          startDate: "Jul 2020",
          endDate: "May 2021",
          description:
            "Ability to ensure a fluid conversation in English and present myself in an acertive way, ask and give personal information, relate elementary",
        },
        {
          degree: "English level A1 ",
          institution: "Academia de Idiomas SMART",
          startDate: "Jul 2019",
          endDate: "Jul 2020",
          description:
            "Ability to ensure a fluid conversation in English and present myself in an acertive way, ask and give personal information, relate elementary",
        }        
      ],
      certificate: [
        {
          name: "Angular Avanzado",
          institution: "Udemy",
          date: "Ene 2020",
          description:
            "Angular Intermedio MEAN, Google Signin, JWT, carga de archivos, lazyload, optimizaciones, Git, GitHub",
        },
        {
          name: "Angular de cero a experto",
          institution: "Udemy",
          date: "May 2020",
          description:
            "Angular de cero a experto creando aplicaciones (Angular 9 +)",
        },
        {
          name: "REDUX en Angular con NGRX",
          institution: "Udemy",
          date: "Jun 2020",
          description:
            "Redux en Angular con NGRX: Desde las bases hasta la práctica",
        },
        {
          name: "Visual Studio Code",
          institution: "Udemy",
          date: "Jun 2020",
          description: "Mejora tu velocidad para codificar",
        },
        {
          name: "Git + GitHub",
          institution: "Udemy",
          date: "Jun 2020",
          description: "Todo un sistema de control de versiones de cero",
        },
        {
          name: "Gestionar la Calidad del Código Fuente con SonarQube",
          institution: "Udemy",
          date: "Mar 2020",
          description:
            "Construye & Entrega Software de Calidad que cumplan requisitos de Confiabilidad, Mantenibilidad & Seguridad",
        },
        {
          name: "C# Linq",
          institution: "Udemy",
          date: "Dec 2019",
          description: "Curso de linq",
        },
        {
          name: "C# Master",
          institution: "Udemy",
          date: "Dec 2019",
          description: "Curso de C#",
        },
        {
          name: "60 + Herramientas de desarrollo y diseño Web",
          institution: "Udemy",
          date: "Dec 2020",
          description: "Desarrollo y Diseño Web",
        },
        {
          name: "Servicios Windows Communication Foundation (WCF)",
          institution: "Udemy",
          date: "Jan 2018",
          description:
            "Diseñar, construir y desplegar Servicios Windows Communication Foundation (WCF) con Visual Studio. NET 2013/2015/2017",
        },
        {
          name: "Tutorial Course C#",
          institution: "Solo Learn",
          date: "Jun 2019",
          description: "Curso de C#",
        },
        {
          name: "Tutorial SQL",
          institution: "Solo Learn",
          date: "Jul 2019",
          description: "Curso de SQL",
        },
        {
          name: "Tutorial JavaScript",
          institution: "Solo Learn",
          date: "Jul 2019",
          description: "Curso de JavaScript",
        },
        {
          name: "Full Stack Developer",
          institution: "Fedesoft",
          date: "Jan 2018",
          description:
            "Prototipado inicial, patrones de diseño programación web en HTML5, JavaScript y CC3, Programación Backend en Ruby, Bases de datos, patrones animados de diseño de apps, desarrollo de aplicaciones híbridas nativas, compilación de aplicaciones web a nativas Android, IOS, Windows.",
        },
      ],
      skills: [
        { name: ".Net C#", percentage: "80%" },
        { name: "Angular 9", percentage: "80%" },
        { name: "SQL Server", percentage: "80%" },
        { name: "HTML5", percentage: "90%" },
        { name: "Angular JS", percentage: "70%" },
        { name: "React", percentage: "80%" },
        { name: "CSS", percentage: "90%" },
        { name: "JavaScript", percentage: "100%" },
        { name: "Git", percentage: "80%" },
        { name: "Ingles A1", percentage: "100%" },
        { name: "Ingles A2", percentage: "100%" },
        { name: "Ingles A1", percentage: "10%" },
      ],
    };

    return (
      <header>
        <div className="wrapper">
          <div className="sidebar">
            <About
              avatar={person.avatar}
              name={person.name}
              profession={person.profession}
              telephohe={person.telephohe}
              bio={person.bio}
              address={person.address}
              social={person.social}
            />
          </div>

          <div className="content-wrapper">
            <div className="content">
              <Profile profile={person.profile} />
              <Experience experience={person.experience} />
              <Education education={person.education} />
              <Certificate certificate={person.certificate} />
              <Skills skills={person.skills} />
            </div>
          </div>
        </div>
      </header>
    );
  }
}
export default App;
